/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react'
import { TreeView } from '@material-ui/lab'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { filter, reduce, orderBy, get } from 'lodash'
import { Typography, makeStyles } from '@material-ui/core'
import Criteria from './Criteria'

const useStyle = makeStyles((theme) => ({
  link: {
    ...theme.typography.subtitle1,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}))

const SectionTreeView = ({ section, hidden, selectSectionText }) => {
  const classes = useStyle()
  const [allNodeIds, setAllNodeIds] = useState([])
  const [expanded, setExpanded] = useState(
    section.criterias.map((criteria) => `cri-${criteria.id}`),
  )

  const choicesReducer =
    (criteriaNodeId) => (allChoiceNodeIds, choice, index) => {
      const choiceNodeId = `${criteriaNodeId}/cho-${index}`

      return [
        ...allChoiceNodeIds,
        choiceNodeId,
        ...(choice.linked_criterias
          ? getCriteriaNodeIds(choice.linked_criterias, choiceNodeId)
          : []),
      ]
    }

  const criteriasReducer = (parentNodeId) => (allCriteriaNodeIds, criteria) => {
    const criteriaNodeId = `${parentNodeId}${parentNodeId ? '/' : ''}cri-${
      criteria.id
    }`
    return [
      ...allCriteriaNodeIds,
      criteriaNodeId,
      ...reduce(
        orderBy(
          get(criteria, 'choices', []),
          ['is_text_or_extended'],
          ['desc'],
        ),
        choicesReducer(criteriaNodeId),
        [],
      ),
    ]
  }

  const getCriteriaNodeIds = (criterias, parentNodeId = '') => {
    return reduce(criterias, criteriasReducer(parentNodeId), [])
  }

  const openCriteriaAndHisChoices = (selectedNodeId) => {
    const selectedNodeIdDepth = selectedNodeId.split('/').length
    setExpanded([
      ...expanded,
      selectedNodeId,
      ...filter(
        allNodeIds,
        (nodeId) =>
          nodeId.startsWith(selectedNodeId) &&
          nodeId.split('/').length === selectedNodeIdDepth + 1,
      ),
    ])
  }

  const onNodeSelect = (e, selectedNodeId) => {
    if (expanded.includes(selectedNodeId)) {
      setExpanded(
        filter(expanded, (nodeId) => !nodeId.startsWith(selectedNodeId)),
      )
    } else {
      openCriteriaAndHisChoices(selectedNodeId)
    }
  }

  useEffect(() => {
    const nodeIds = getCriteriaNodeIds(section.criterias)
    setAllNodeIds(nodeIds)
    setExpanded(nodeIds)
  }, [section])

  const handleClick = () => {
    document.getElementById('SectionTab0').focus()
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('SectionTab0').focus()
    }
  }

  return (
    <TreeView
      key={section.id}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      hidden={hidden}
      expanded={expanded}
      onNodeSelect={onNodeSelect}
    >
      {section.criterias.map((criteria) => (
        <Criteria key={criteria.id} criteria={criteria} />
      ))}
      <Typography
        className={classes.link}
        variant="subtitle1"
        component="nav"
        tabIndex="0"
        onClick={handleClick}
        onKeyPress={handleKeyPress}
        gutterBottom={false}
      >
        {selectSectionText ||
          'Revenir à la sélection des sections du référentiel'}
      </Typography>
    </TreeView>
  )
}

export default SectionTreeView
